<template>
    <sa-page-layout :btnConfigurazioniVisible="btnConfigurazioniVisible" :btnRefreshVisible="true" @refresh="onRefresh" :pathResource="pathResource" :showModalLoading="showModalLoading">
        <template slot="toolbar">
            <b-button class="float-sm-right" variant="success btn-toolbar sa-margin-right" size="sm" @click="onClickNuovaStanza">
                <b-icon icon="plus"></b-icon>
                Nuovo
            </b-button>
        </template>
        <template slot="table-filter">
            <b-form @submit.prevent="onSubmit">
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Struttura</label>
                        <b-form-input v-model="filtro.denominazioneStruttura" type="search" id="denominazioneStruttura" placeholder="Nome Struttura"></b-form-input>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Presidio</label>
                        <b-form-input v-model="filtro.denominazionePresidio" type="search" id="denominazionePresidio" placeholder="Nome Presidio"></b-form-input>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Nome</label>
                        <b-form-input v-model="filtro.nome" type="search" id="nome" placeholder="Inserire nome stanza"></b-form-input>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="sa-padding-right pt-3 pb-3 text-right">
                        <b-button type="submit" variant="info">{{ this.$i18n.t("patients.lblFind") }}</b-button>
                        <b-button type="reset" v-on:click="onReset" variant="danger">{{ this.$i18n.t("patients.lblResetFilter") }}</b-button>
                    </b-col>
                </b-row>
            </b-form>
        </template>
        <template slot="table-body">
            <ras-configurazione-posti-letto-stanze-list-component ref="cmpConfigurazionePostiLettoStanzeList" @beforeLoadData="onBeforeLoadData" @afterLoadData="onAfterLoadData"></ras-configurazione-posti-letto-stanze-list-component>
        </template>
    </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import RasConfigurazionePostiLettoStanzeListComponent from "../components/RasConfigurazionePostiLettoStanzeListComponent.vue";
export default {
    components: { SaPageLayout, RasConfigurazionePostiLettoStanzeListComponent },
    data() {
        return {
            filtro: {},
            pathResource: "rsaconfigurazionepostilettostanze",
            linkedit: "/rsaconfigurazionepostilettostanze",
            linkback: "rsaconfigurazionepostilettostanze",
            showModalLoading: false,
            btnConfigurazioniVisible: true,
        };
    },
    mounted() {
        let me = this;
        me.loadData();
    },
    methods: {
        loadData() {
            let me = this;
            me.showModalLoading = true;
            me.$refs.cmpConfigurazionePostiLettoStanzeList.loadData();
        },
        onRefresh() {
            let me = this;
            me.loadData();
        },
        onAfterLoadData() {
            let me = this;
            console.log("B");
            me.showModalLoading = false;
        },
        onBeforeLoadData() {
            let me = this;
            console.log("A");

            me.showModalLoading = true;
        },
        onReset() {
            let me = this;
            me.filtro = {};
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtro"] = JSON.stringify(me.filtro);
            me.loadData();
        },
        onSubmit() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtro"] = JSON.stringify(me.filtro);
            me.loadData();
        },
        onClickNuovaStanza() {
            let me = this;
            me.$refs.cmpConfigurazionePostiLettoStanzeList.onClickNuovaStanza();
        },
    },
};
</script>

<style></style>
